import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';

import { FavoriteBtnComponent } from './favorite-btn.component';
import { FavoriteBtnService } from './favorite-btn.service';
import { FavoriteBtnEffects } from './store/favorite-btn.effects';

@NgModule({
  imports: [IonicModule, CommonModule, EffectsModule.forFeature([FavoriteBtnEffects])],
  declarations: [FavoriteBtnComponent],
  exports: [FavoriteBtnComponent],
  providers: [FavoriteBtnService],
})
export class FavoriteBtnModule {}
